import * as model from './model.js';
import recipeView from './views/recipeView.js';
import svg from 'url:../img/icons.svg';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { async } from 'regenerator-runtime';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import paginationView from './views/paginationView.js';
import bookmarksView from './views/bookmarksView.js';
import addRecipeView from './views/addRecipeView.js';
import { CLOSE_TIME_SEC } from './config.js';

const controlRecipes = async function () {
  try {
    // recipeView.renderSpinner();
    const id = window.location.hash.slice(1);

    if (!id) return;
    recipeView.renderSpinner();

    // 0)
    resultsView.update(model.getSearchResultsPage());

    // 1) Loading recipe
    await model.loadRecipe(id);

    // 2) Rendering recipe
    recipeView.render(model.state.recipe);
    // console.log(model.state.recipe);
    // debugger;
    if (model.state.bookmarks.length === 0) bookmarksView.renderError();
    bookmarksView.update(model.state.bookmarks);
  } catch (err) {
    recipeView.renderError();
    console.error(err);
  }
};
const controlSearchResults = async function () {
  try {
    resultsView.renderSpinner();
    // 1) Get search Query from UI
    const query = searchView.getQuery();
    if (!query) return;

    // 2) Search for it on server
    await model.loadSearchResults(query);

    // 3) Render Results
    console.log(model.state.search.results);
    resultsView.render(model.getSearchResultsPage());

    // 4) render pagination buttons
    paginationView.render(model.state.search);
  } catch (err) {
    console.error(err);
  }
};

const controlPagination = function (goToPage) {
  // 3) Render NEW Results
  console.log(model);
  resultsView.render(model.getSearchResultsPage(goToPage));

  // 4) render NEW pagination buttons
  paginationView.render(model.state.search);
};

const controlServings = function (newServings) {
  // Update the ingredients
  model.updateServings(newServings);

  // Update the recipe UI
  recipeView.update(model.state.recipe);
};

const controlBookmark = function () {
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);
  // console.log(model.state.recipe);
  recipeView.update(model.state.recipe);

  // render bookmarks
  bookmarksView.render(model.state.bookmarks);
};

const bookmark = function () {
  bookmarksView.render(model.state.bookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  try {
    // show spinner
    addRecipeView.renderSpinner();

    console.log(newRecipe);
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);

    //render
    recipeView.render(model.state.recipe);
    //success
    addRecipeView.renderMessage();

    // render bookmark view
    bookmarksView.render(model.state.bookmarks);

    // change hash
    window.history.pushState(null, '', `#${model.state.recipe.id}`);

    //Closeing modal
    setTimeout(function () {
      addRecipeView.toggleWindow();
    }, CLOSE_TIME_SEC * 1000);
  } catch (err) {
    addRecipeView.renderError(err.message);
    console.error(err);
  }
};

const init = function () {
  bookmarksView.addHandlerRender(bookmark);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerBookmark(controlBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  recipeView.addHandlerServings(controlServings);
  addRecipeView.addHandlerUpload(controlAddRecipe);
};
init();
